import type { IconProps } from "@highoutput/ui-components";
import { Icon } from "@highoutput/ui-components";

function Confetti2Desktop(props: IconProps) {
  return (
    <Icon
      width="427"
      height="108"
      viewBox="0 0 427 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="427"
        height="108"
        viewBox="0 0 427 108"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 105.235C15.4528 64.8768 144.414 -17.4638 187.556 6.19462C217.013 22.4308 139.544 60.0059 143.719 78.7934C146.966 93.406 247.166 46.3212 258.068 43.3059C301.441 31.0128 258.299 72.9949 289.38 76.706C328.811 81.3449 400.714 29.853 442 17.328"
          stroke="current"
          strokeWidth="3.9714"
          strokeMiterlimit="5.5118"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
}
function Confetti2Mobile(props: IconProps) {
  return (
    <Icon
      width="106"
      height="32"
      viewBox="0 0 106 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="106"
        height="32"
        viewBox="0 0 106 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 30C5.63838 19.0538 40.5166 -3.27907 52.1845 3.13769C60.1513 7.54134 39.1993 17.7327 40.3284 22.8283C41.2066 26.7916 68.3063 14.021 71.2546 13.2032C82.9852 9.86899 71.3173 21.2556 79.7233 22.2622C90.3875 23.5203 109.834 9.55444 121 6.15733"
          stroke="current"
          strokeWidth="3.9714"
          strokeMiterlimit="5.5118"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
}

export { Confetti2Mobile, Confetti2Desktop };
